import React, { Component } from "react"

import { MIDDLE_PURPLE } from "shared/imports/sharedConstants"

import {
    federalRegions,
    stateRegions,
    // localRegions,
    federalAndStates,
    usRegions,
    euRegions,
    usEURegion,
} from "shared/imports/regionConstants"

import {
    genericBarPieScene,
    genericMapScene,
    createUSMapScene,
} from "search-new/containers/Visualization/VisualizationScene/VisualizationScenes"

import { federalMapConfig, euMapConfig } from "search-new/components/Visualization/VisualizationWrappers/MapConfigs"

import { RepresentingStateFilter } from "shared/search/containers/Filter/Filters"

import { inIssueFilter } from "shared/search/containers/Filter/FilterCreators"

import { PersonRepresentingCountryEUFilter, OfficialPartyFilter } from "shared/search/containers/Filter/OfficialFilters"

/* *****************************************************************
 * MAPS
 ******************************************************************* */
export const PersonMapScene = createUSMapScene({ filterId: RepresentingStateFilter.defaultProps.uniqueFilterId })

export class PersonEUMapScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "euMapScene",
        filterId: PersonRepresentingCountryEUFilter.defaultProps.uniqueFilterId,
        label: "Map",
        icon: "fa-location-arrow",
        configs: euMapConfig,
        regions: euRegions,
    }

    render() {
        return genericMapScene(this.props)
    }
}

/* *****************************************************************
 * BAR / PIE COMBO GRAPHS
 ******************************************************************* */
export const OfficialInIssuesBarPieScene = (props) => genericBarPieScene(props)
OfficialInIssuesBarPieScene.defaultProps = {
    uniqueVizSceneId: "officialInIssuesBarPieScene",
    filterId: inIssueFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "inIssueFrequency",
    label: "Issues",
    icon: DjangIO.app.models.QuorumDataType.issue_management.icon,
    sidebarTableLabel: "Officials tagged to Issue",
}

export class OfficialPartyBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "officialPartyBarPieScene",
        filterId: OfficialPartyFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "partyFrequency",
        label: "Party",
        icon: "fa-check-square-o",
        colorConfigs: {
            secondaryColor: MIDDLE_PURPLE,
            colorFunc: (d, i) => DjangIO.app.person.types.Party.by_value(d.id).color,
        },
        sidebarTableLabel: "Party Affiliation",
        noOrgDesign: true,
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

/* *****************************************************************
 * LINE GRAPH (TREND)
 ******************************************************************* */
